import React from 'react';
import Head from 'expo-router/head';
import { Asset } from 'expo-asset';

const scene = Asset.fromModule(require('@/assets/images/about-life-family.webp')).uri;
const sceneNarrow = Asset.fromModule(require('@/assets/images/about-life-family-1000w.webp')).uri;
const srcSet = `${sceneNarrow} 1000w, ${scene} 1280w`;
const sizes = '(max-width: 720px) calc(100vw - 30px), (max-width: 1280px) calc(100vw - 80px), 1200px';

const coverStyle = {
  position: 'absolute',
  inset: 0,
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  imageRendering: 'pixelated',
};

/** Above-the-fold About art: responsive WebP plus a preload for LCP. */
export default function AboutLifeScene() {
  return (
    <div style={{ width: '100%', aspectRatio: '16 / 9', position: 'relative', overflow: 'hidden', backgroundColor: '#40644A' }}>
      <Head>
        <link rel="preload" as="image" type="image/webp" href={scene} imageSrcSet={srcSet} imageSizes={sizes} fetchPriority="high" />
      </Head>
      <img
        src={scene}
        srcSet={srcSet}
        sizes={sizes}
        alt="A family sits together on a lakeside dock while a robot works at a laptop on the shore."
        fetchPriority="high"
        decoding="async"
        style={coverStyle}
      />
    </div>
  );
}
